import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { filterNilOrEmptyValues } from '@hems/util/src/helper/helper';
export default class ActivityHistoryService extends Service {
    constructor(axios) {
        super(axios);
    }
    getRecentActivityList = async () => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/activities/dashboards'));
        return data;
    };
    getActivityList = async (params) => {
        return await this.get(apiWrapper.managerApiV1('/site-activities'), filterNilOrEmptyValues(params));
    };
}
